module.exports = __webpack_public_path__ + "static/media/lock.bdec09c4.jpg";